import React from 'react';

export function PseudoLabel(props: { 
	value: string,
	className?: string,
	"data-name"?: string,
	style?: React.CSSProperties
})
{
	return (
		<input data-name={props["data-name"]}
			readOnly
			type={"text"}
			className={["pseudoLabel", props.className].join(" ")}
			style={props.style}
			value={props.value} 
			size={props.value.length}
		/>
	);
}
